import React, { useState, useEffect, useRef, Fragment } from "react";
import i18n from "../i18n.js";
import { parseJSON, format, compareAsc, compareDesc, parse } from "date-fns";
import { pl } from "date-fns/locale";
import axios from "axios";
import Box from "@mui/material/Box";
import LinkMui from "@mui/material/Link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Collapse from "@mui/material/Collapse";
import ToggleButton from "@mui/material/ToggleButton";
import Avatar from "@mui/material/Avatar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import LinearProgress from "@mui/material/LinearProgress";
const Category = ({ cat }) => {
    // console.log(cat);
    let color = "default";
    let name = cat.shortName;
    // console.log(cat);
    if (cat.additionalDescription !== null && cat.additionalDescription !== "") {
        name = `${name} (${cat.additionalDescription})`;
    }
    if (cat.competitionType !== undefined) {
        if (cat.competitionType.name?.includes("WDSF") || cat.competitionType.name?.includes("DSE")) {
            color = "error";
        } else if (cat.competitionType.id == 5) {
            color = "info";
        } else if (cat.shortName.includes("MP") || cat.competitionType.id == 4 || cat.shortName.includes("MW") || cat.shortName.includes("MK")|| cat.shortName.includes("MDiJI")) {
            color = "success";
        } else if (cat.class === "IF") {
            color = "warning";
        }
    }
    return <Chip color={color} sx={{ m: 0.25 }} variant="outlined" label={name} />;
};

const EventType = ({ type, t }) => {
    let color = "primary";
    let label = t("calendar.pzst");

    let src = "/img/pzst_logo.png";
    if (type === "fts") {
        label = t("calendar.fts");
        src = "/img/fts_logo3.svg";
    } else if (type === "ztn") {
        label = t("calendar.ztn");
        src = "/img/ztn_circle.png";
    }

    return <Avatar sx={{ bgcolor: "white", width: 50, height: 50 }} alt={label} src={src} variant="rounded"></Avatar>;
};
const a11yProps = index => {
    return {
        id: `vertical-tab-${index}`,
        "aria-controls": `vertical-tabpanel-${index}`
    };
};

const TabPanel = props => {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`vertical-tabpanel-${index}`} aria-labelledby={`vertical-tab-${index}`} {...other}>
            {value === index && <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>{children}</Box>}
        </div>
    );
};

const Competition = ({ c, t }) => {
    const [open, setOpen] = useState(false);
    // console.log(c);
    return (
        <Card
            raised={true}
            key={`c-${c.id}`}
            sx={{
                width: "100%"
            }}
        >
            <CardHeader
                action={
                    <>
                        <Button variant="text" endIcon={<FontAwesomeIcon icon={faLocationDot} />}>
                            {c.city.name}
                        </Button>
                    </>
                }
                avatar={<EventType type={c.type} t={t} />}
                title={
                    <Box sx={{ display: { xs: "none", sm: "block" } }}>
                        {c.status.id === 3 && <Chip color="error" label={t("comp.status.cancelled")} />} <span style={{ textDecoration: c.status.id === 3 ? 'line-through' : 'none' }}>{c.competitionName}</span>
                    </Box>
                }
                subheader={<Box sx={{ display: { xs: "none", sm: "block" } }}>{c.dates}</Box>}
            />
            <CardContent sx={{ p: "8px" }}>
                <Box sx={{ display: { xs: "block", sm: "none" } }}>
                    <Typography variant="subtitle1" gutterBottom>
                        {c.dates}
                    </Typography>
                    <Typography variant="subtitle2" gutterBottom>
                        {c.status.id === 3 && <Chip color="error" label={t("comp.status.cancelled")} />} <span style={{ textDecoration: c.status.id === 3 ? 'line-through' : 'none' }}>{c.competitionName}</span>
                    </Typography>
                </Box>
                <Collapse in={open}>
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap"
                        }}
                    >
                        {c.categories?.map(cat => (
                            <Category key={cat.id} size="small" cat={cat} />
                        ))}
                    </Box>
                </Collapse>
            </CardContent>
            <CardActions>
                <Stack direction={"row"} flexWrap={"wrap"} sx={{ rowGap: 1, columnGap: 1 }}>
                    {c.categories && c.categories.length > 0 && (
                        <ToggleButton
                            value="check"
                            color="warning"
                            size="small"
                            selected={open}
                            onChange={() => {
                                setOpen(!open);
                            }}
                        >
                            {t("categories")}
                        </ToggleButton>
                    )}
                    {c.urls.website === null && c.urls.registration !== null && (
                        <LinkMui href={c.urls.registration} rel="noopener" target="_blank" sx={{ textDecoration: "none" }}>
                            <Button variant="contained" color="primary" size="small">
                                {t("calendar.registration")}
                            </Button>
                        </LinkMui>
                    )}
                    {c.urls.website !== null && (
                        <LinkMui href={c.urls.website} rel="noopener" target="_blank" sx={{ textDecoration: "none" }}>
                            <Button variant="contained" color="primary" size="small">
                                {t("calendar.website")}
                            </Button>
                        </LinkMui>
                    )}

                    {c.links.map(l => {
                        {/* console.log(l.link.includes("_D.pdf")); */}
                        return(
                        <LinkMui key={l.id} href={l.link} rel="noopener" target="_blank" sx={{ textDecoration: "none" }}>
                            {l.isPdf && (
                                <Button size="small" color="secondary">
                                    {l.link.includes("_D.pdf") && <>{t("calendar.disqualifications")}</>}
                                    {l.link.includes("_punkty.pdf") && <>{t("calendar.points")}</>}
                                    {!l.link.includes("_D.pdf") && !l.link.includes("_punkty.pdf") && <>{t("calendar.results")}</>}
                                    {/* {t("calendar.results")} */}
                                </Button>
                            )}
                            {!l.isPdf && (
                                <Button size="small" key={l.id}>
                                    {t("calendar.live_results")}
                                </Button>
                            )}
                        </LinkMui>
                    )})}
                    {/* <Button size="small">Learn More</Button> */}
                </Stack>
            </CardActions>
        </Card>
    );
};
const Root = props => {
    // eslint-disable-next-line react/prop-types
    const { itemOptions } = props;
    const { pzst, fts, ztn, api } = itemOptions;
    const { t } = i18n;
    const [selected, setSelected] = useState(false);
    const [availablePzstComps, setAvailablePzstComps] = useState(pzst.comps);
    const [availableFtsComps, setAvailableFtsComps] = useState([]);
    const [availableZtnComps, setAvailableZtnComps] = useState([]);
    const [comps, setComps] = useState([]);
    const [months, setMonths] = useState([]);
    const [monthsComps, setMonthsComps] = useState([]);
    const [value, setValue] = useState(0);
    const [availablePzstCompsArchive, setAvailablePzstCompsArchive] = useState(pzst.archive);
    const [availableFtsCompsArchive, setAvailableFtsCompsArchive] = useState([]);
    const [availableZtnCompsArchive, setAvailableZtnCompsArchive] = useState([]);

    const [compsArchive, setCompsArchive] = useState([]);
    const [monthsArchive, setMonthsArchive] = useState([]);
    const [monthsCompsArchive, setMonthsCompsArchive] = useState([]);
    const [valueArchive, setValueArchive] = useState(0);
    const handleChangeValue = (event, newValue) => {
        setValue(newValue);
    };
    const handleChangeValueArchive = (event, newValue) => {
        setValueArchive(newValue);
    };
    const [fetched, setFetched] = useState(false);
    const [fetchedArchive, setFetchedArchive] = useState(false);

    const [archive, setArchive] = React.useState(false);

    // New: track if archive data has been loaded
    const [archiveLoaded, setArchiveLoaded] = useState(false);

    const handleChangeArchive = (event, newState) => {
        setArchive(newState);
        if (newState && !archiveLoaded) {
            setFetchedArchive(false);
            let ftsOk = false;
            let ztnOk = false;
            let pzstOk = false;
            axios.get(api.pzstEventsArchive, {}).then(res1 => {
                if (res1.status === 200) {
                    let tmpComps = [];
  
                    res1.data.forEach(e => {
                        if (e.status.visibleInCalendar===true) {
                            // console.log(1);
                            tmpComps.push({ ...e, type: "pzst" });
                        }
                    });
                    setAvailablePzstCompsArchive(tmpComps);
                    pzstOk = true;
                }
            });
            axios.get(api.ftsEventsArchive, { auth: { username: fts.u, password: fts.p } }).then(res1 => {
                if (res1.status === 200) {
                    let tmpComps = [];
                    res1.data.forEach(e => {
                        if (e.status.visibleInCalendar) {
                            tmpComps.push({ ...e, type: "fts" });
                        }
                    });
                    setAvailableFtsCompsArchive(tmpComps);
                    ftsOk = true;
                }
            });
            axios.get(api.ztnEventsArchive, { auth: { username: ztn.u, password: ztn.p } }).then(res1 => {
                if (res1.status === 200) {
                    let tmpComps = [];
                    res1.data.forEach(e => {
                        if (e.status.visibleInCalendar) {
                            tmpComps.push({ ...e, type: "ztn" });
                        }
                    });
                    setAvailableZtnCompsArchive(tmpComps);
                    ztnOk = true;
                }
            });
            // Set as loaded after all fetches (simple version, could be improved with Promise.all)
            setArchiveLoaded(true);
        }
    };
    useEffect(() => {
        axios
            .get(api.ftsEvents, {
                auth: {
                    username: fts.u,
                    password: fts.p
                }
            })
            .then(res1 => {
                if (res1.status === 200) {
                    let tmpComps = [];
                    res1.data.forEach(e => {
                        if (e.status.visibleInCalendar) {
                            tmpComps.push({
                                ...e,
                                type: "fts"
                            });
                        }
                    });
                    setAvailableFtsComps(tmpComps);
                }
            });
        axios
            .get(api.ztnEvents, {
                auth: {
                    username: ztn.u,
                    password: ztn.p
                }
            })
            .then(res1 => {
                if (res1.status === 200) {
                    let tmpComps = [];
                    res1.data.forEach(e => {
                        if (e.status.visibleInCalendar) {
                            // console.log(e);

                            tmpComps.push({
                                ...e,
                                type: "ztn"
                            });
                        }
                    });

                    setAvailableZtnComps(tmpComps);
                }
            });
    }, []);
    useEffect(() => {
        const tmpComs = [...availablePzstComps, ...availableFtsComps, ...availableZtnComps].sort((a, b) => {
            const d1 = parse(a.dateStart, "y-MM-dd", new Date());
            const d2 = parse(b.dateStart, "y-MM-dd", new Date());
            if (compareAsc(d1, d2) === 0) {
                return a.city.name.localeCompare(b.city.name);
            } else {
                return compareAsc(d1, d2);
            }
        });
        setComps(tmpComs);
    }, [availableFtsComps, availablePzstComps, availableZtnComps]);

    useEffect(() => {
        const tmpComs = [...availablePzstCompsArchive, ...availableFtsCompsArchive, ...availableZtnCompsArchive].sort((a, b) => {
            const d1 = parse(a.dateStart, "y-MM-dd", new Date());
            const d2 = parse(b.dateStart, "y-MM-dd", new Date());
            if (compareAsc(d1, d2) === 0) {
                return a.city.name.localeCompare(b.city.name);
            } else {
                return compareAsc(d1, d2);
            }
        });
        setCompsArchive(tmpComs);
    }, [availableFtsCompsArchive, availablePzstCompsArchive, availableZtnCompsArchive]);
    useEffect(() => {
        let tmpMonths = {};
        let tmpComps = {};
        // let index = 0;
        comps.forEach(c => {
            const tmpDate = parse(c.dateStart, "y-MM-dd", new Date());
            const index = format(tmpDate, "yyyyLL");
            tmpMonths[index] = format(tmpDate, "LLLL yyyy", { locale: pl });
            if (tmpComps[index] === undefined) {
                tmpComps[index] = [];
            }
            tmpComps[index].push(c);
        });
        setMonthsComps(tmpComps);
        setMonths(tmpMonths);
    }, [comps]);
    useEffect(() => {
        let tmpMonths = {};
        let tmpComps = {};
        compsArchive.forEach(c => {
            const tmpDate = parse(c.dateStart, "y-MM-dd", new Date());
            const index = format(tmpDate, "yyyyLL");
            tmpMonths[index] = format(tmpDate, "LLLL yyyy", { locale: pl });
            if (tmpComps[index] === undefined) {
                tmpComps[index] = [];
            }
            tmpComps[index].push(c);
        });

        setMonthsCompsArchive(tmpComps);
        setMonthsArchive(tmpMonths);
    }, [compsArchive]);
    // console.log(availablePzstComps);

    const monthsCal = archive ? monthsArchive : months;
    const monthsCompsCal = archive ? monthsCompsArchive : monthsComps;
    const valueCal = archive ? valueArchive : value;
    const handleChangeCal = archive ? handleChangeValueArchive : handleChangeValue;
    return (
        <React.Fragment>
            <Box sx={{ minHeight: "100vh" }}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <ToggleButtonGroup size="small" value={archive} exclusive onChange={handleChangeArchive} aria-label="Archive">
                        <ToggleButton value={false}>{t("calendar.current")}</ToggleButton>
                        <ToggleButton value={true}>{t("calendar.archive")}</ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                <Box sx={{ flexGrow: 1, bgcolor: "background.paper", display: "flex", flexDirection: "column" }}>
                    <Tabs value={valueCal} onChange={handleChangeCal} variant="scrollable" scrollButtons="auto" aria-label="month tabs">
                        {archive &&
                            Object.entries(monthsCal)
                                .sort()
                                .reverse()
                                .map(([k, v], index) => <Tab label={v} key={k} {...a11yProps(index)} />)}
                        {!archive &&
                            Object.entries(monthsCal)
                                .sort()
                                .map(([k, v], index) => <Tab label={v} key={k} {...a11yProps(index)} />)}
                    </Tabs>
                    {archive && !fetchedArchive && (
                        <Box sx={{ width: "100%", marginTop: 1 }}>
                            <LinearProgress />
                        </Box>
                    )}
                    {archive &&
                        Object.entries(monthsCompsCal)
                            .sort()
                            .reverse()

                            .map(([k, v], index) => (
                                <TabPanel value={valueCal} index={index} key={k}>
                                    <Stack spacing={1}>
                                        {v?.map(c => (
                                            <Competition key={`c-${c.id}`} c={c} t={t} />
                                        ))}
                                    </Stack>
                                </TabPanel>
                            ))}
                    {!archive &&
                        Object.entries(monthsCompsCal).map(([k, v], index) => (
                            <TabPanel value={valueCal} index={index} key={k}>
                                <Stack spacing={1}>
                                    {v?.map(c => (
                                        <Competition key={`c-${c.id}`} c={c} t={t} />
                                    ))}
                                </Stack>
                            </TabPanel>
                        ))}
                </Box>
            </Box>
        </React.Fragment>
    );
};

export default Root;
